import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import RestoreIcon from "@mui/icons-material/Restore";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ArchiveIcon from "@mui/icons-material/Archive";
import Paper from "@mui/material/Paper";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import FolderIcon from "@mui/icons-material/Folder";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import { ThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import MainPage from "./containers/MainPage";
import StudyCards from "./containers/StudyCards/StudyCards";
import { darkTheme, lightTheme } from "../layouts/theme/index";
import { ToastContainer, toast } from "react-toastify";
import { getBoxesListApi } from "../services/leitnerApi";
import { checkResponseData, customToastify, checkErrorMessage } from "./utils/utils";

const cacheRTL = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

export default function AppLeitner() {
  const [lighteMode, setLightMode] = useState(false);
  const [boxesList, setBoxesList] = useState([{}]);
  const [startStudy, setStartStudy] = useState(false);
  const [studyCards, setStudyCards] = useState({ boxInfo: {}, boxCards: [] });
  const [oneBox, setOneBox] = useState({ state: false, boxId: null });
  const [userTypes, setUserTypes] = useState([]);
  const setBoxDetails = (state, id) => {
    try {
      setOneBox({ state: state, boxId: id });
    } catch (error) {
      console.error(error);
    }
  };

  const handleUserTypes = (types) => {
    setUserTypes(types);
  };

  const handleStartStudy = (status) => {
    setStartStudy(status);
  };

  const handleStudyCards = (data) => {
    setStudyCards(data);
  };
  const controlThemeMode = () => {
    setLightMode(!lighteMode);
    localStorage.setItem("themeMode", !lighteMode);
  };

  const handleEditBoxlist = (data) => {
    // console.log("datatattat",data)
    setBoxesList(data);
  };
  const CheckInitialMode = async () => {
    const toastMsg = toast.loading("لطفا صبر کنید...")

    try {
      const themeMode = JSON.parse(localStorage.getItem("themeMode"));
      if (themeMode) {
        setLightMode(themeMode);
      } else {
        console.log("Theme Mode is Dark");
      }
      const getBoxesList = await getBoxesListApi({})
      const resData = checkResponseData(getBoxesList);
      if (resData["success"]) {
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });

        setBoxesList(checkResponseData(getBoxesList)["data"]["docs"]);
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
        setBoxesList([{}]);
        customToastify(
          "error",
          "مشکلی در دریافت لیست کارتهای لایتنر وجود دارد",
          5000,
          "bottom-center"
        );
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      console.log("Problem in theme Mode");
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
    }
  };
  function CheckUserSignIn() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      if (token) {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        const typeUser = JSON.parse(jsonPayload)["type"];
        setUserTypes(typeUser);
        CheckInitialMode()
      } else {
        // در نسخه نهایی user باید پاک شود
        setUserTypes([""]);
      }
    } catch {
      // در نسخه نهایی user باید پاک شود
      setUserTypes([""]);
    }
  }
  useEffect(() => {
    CheckUserSignIn();
  }, []);


  return (
    <CacheProvider value={cacheRTL}>
      <ThemeProvider theme={lighteMode ? lightTheme : darkTheme}>
        <HelmetProvider>
          <Helmet>
            <title>UMLANG  - یادگیری زبان با استفاده از فیلم (اوملنگ)</title>
          </Helmet>
          <Box sx={{ pb: 7 }}>
            {startStudy ? (
              <StudyCards
                setBoxDetails={setBoxDetails}
                oneBox={oneBox}
                controlThemeMode={controlThemeMode}
                studyCards={studyCards}
                handleStartStudy={handleStartStudy}
              // handleStudyCards={handleStudyCards}
              />
            ) : (
              <MainPage
                userTypes={userTypes}
                handleUserTypes={handleUserTypes}
                CheckUserSignIn={CheckUserSignIn}
                setBoxDetails={setBoxDetails}
                oneBox={oneBox}
                controlThemeMode={controlThemeMode}
                boxesList={boxesList}
                handleEditBoxlist={handleEditBoxlist}
                handleStartStudy={handleStartStudy}
                handleStudyCards={handleStudyCards}
              />
            )}

            {/* <>
              <CardMenu />
              <CssBaseline />
              <List dense={true}>
                {messages.map(({ primary, secondary, person }, index) => (
                  <ListItem button key={index + person}>
                    <ListItemIcon>
                      <KeyboardDoubleArrowLeftIcon />
                    </ListItemIcon>
                    <ListItemText primary={primary} />
                  </ListItem>
                ))}
              </List>
            </> */}
            {/* <CardMenu />
            <CssBaseline />
            <StudyCards />
            <List dense={true}>
              {messages.map(({ primary, secondary, person }, index) => (
                <ListItem button key={index + person}>
                  <ListItemIcon>
                    <KeyboardDoubleArrowLeftIcon />
                  </ListItemIcon>
                  <ListItemText primary={primary} />
                </ListItem>
              ))}
            </List>
            <Paper
              sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
              elevation={3}
            >
              <BottomNavigation
                showLabels
                // value={value}
                // onChange={(event, newValue) => {
                //   setValue(newValue);
                // }}
              >
                <BottomNavigationAction
                  label="Recents"
                  icon={<RestoreIcon />}
                  sx={{ color: "red" }}
                />
                <BottomNavigationAction
                  label="Favorites"
                  icon={<FavoriteIcon />}
                />
                <BottomNavigationAction
                  label="Archive"
                  icon={<ArchiveIcon />}
                />
                <BottomNavigationAction label="new" icon={<ArchiveIcon />} />
              </BottomNavigation>
            </Paper> */}
            <ToastContainer
              position={"bottom-center"}
              autoClose={2500}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={true}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
          </Box>
        </HelmetProvider>
      </ThemeProvider>
    </CacheProvider>
  );
}
